import $ from "jquery";
import { breakpoint } from "../breakpoint";

let throttler;
const keyCodes = {
  tab: 9,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  enter: 13,
  space: 32,
  escape: 27,
};

/*
 * Trigger class for Hamburger-like menues
 * params:
 *  $el: jQuery element, burger menu trigger
 *  skipTriggerInTab: when true, confine tabbing behavior to target and
 *    skip trigger (trigger is not a toggle)
 *  preventBodyScroll: if true, locks body on burger open
 */
export class PrimaryHamburger {
  constructor($el, skipTriggerInTab, preventBodyScroll) {
    this.$el = $el;
    this.skipTriggerInTab = skipTriggerInTab;
    this.preventBodyScroll = preventBodyScroll;
    this.$target = $("#" + this.$el.data("target")); // Body of menu
    this.$focus = this.$el.data("focus")
      ? $("#" + this.$el.data("focus"))
      : null; // Element in menu to focus on open
    this.$targetClose = this.$target.find(".js-hamburger-close"); // Close button
    this.$mobileMenuExpand = this.$el.parent();
    this.inMenuMode = false;
    this.$primaryNavMenu = $("#headernavigation");
    this.widerThanTablet = false;
    this.$thingClickedOn = null;
    this.hasMatchingTarget = this.$el
      .parent()
      .hasClass("header__mobile-navigation");

    /* Find legit focusable elements... doing this instead of adding jQuery UI because we're not using it elsewhere */
    this.$targetsFirstTabbable = this.$target
      .find("a, button, :input, [tabindex]")
      .first();
    this.$targetsLastTabbable = this.$target
      .find("a, button, :input, [tabindex]")
      .last();

    this.manageBreakpointBehaviors(false);
    this.bindEvents();
  }

  bindEvents() {
    let thisMenu = this;

    /* Esc key-triggered menu close */
    this.$target.on("keydown", function (e) {
      if (e.keyCode == keyCodes.escape && thisMenu.inMenuMode) {
        e.preventDefault();
        // console.log("keydown escape");
        thisMenu.$target.hide().attr("aria-hidden", "true");
        thisMenu.$el
          .removeClass("is-open")
          .focus(); /* Skip focus back to button and stay there due to preventDefault */
        $("body").removeClass("is-scroll-frozen");
      }
    });

    /* Key triggered button close */
    this.$targetClose.on("keydown", function (e) {
      e.stopPropagation();

      switch (e.keyCode) {
        case keyCodes.escape:
        case keyCodes.enter:
        case keyCodes.space:
        
        thisMenu.CloseSesame();
          /*
            It's possible for multiple triggers to target one menu, so
            ONLY trigger the close behaviors and focus for the currently active trigger
           */
          // if (thisMenu.inMenuMode) {
          //   e.preventDefault();
          //   // console.log("keydown close");
          //   thisMenu.$target.hide().attr("aria-hidden", "true");
          //   thisMenu.$el.removeClass("is-open");
          //   thisMenu.$el.focus();
          //   thisMenu.inMenuMode = false;
          //   $("body").removeClass("is-scroll-frozen");
          // }
          break;
        default:
      }
    });

    this.$el.on("keyup", function (e) {
      e.preventDefault(); /* workaround for FF bug */
    });

    this.$targetsLastTabbable.on("keyup", function (e) {
      e.preventDefault(); /* workaround for FF bug */
    });

    this.$targetsFirstTabbable.on("keyup", function (e) {
      e.preventDefault(); /* workaround for FF bug */
    });

    this.$targetClose.on("keyup", function (e) {
      e.preventDefault(); /* workaround for FF bug */
    });

    /* Click trigger for button close */
    this.$targetClose.on("click", function (e) {
      e.preventDefault();
      // console.log("click close");
      thisMenu.CloseSesame();
      
    });

    /* Keyboard trap for tab, forward tabbing */
    this.$targetsLastTabbable.on("keydown", function (e) {
      if (e.keyCode == keyCodes.tab && !e.shiftKey && thisMenu.inMenuMode) {
        e.preventDefault();
        if (thisMenu.skipTriggerInTab) {
          thisMenu.$targetsFirstTabbable.focus(); /* Re-focus first item */
        } else {
          thisMenu.$el.focus(); /* Skip focus back to button and stay there due to preventDefault */
        }
      }
    });

    /* Keyboard trap for tab, backward tabbing */
    this.$targetsFirstTabbable.on("keydown", function (e) {
      if (e.keyCode == keyCodes.tab && e.shiftKey && thisMenu.inMenuMode) {
        e.preventDefault();
        if (thisMenu.skipTriggerInTab) {
          thisMenu.$targetsLastTabbable.focus(); /* Re-focus first item */
        } else {
          thisMenu.$el.focus(); /* Skip focus back to button and stay there due to preventDefault */
        }
      }
    });

    /* Key controls for burger open trigger */
    this.$el.on("keydown", function (e) {
      // console.log("keydown");
      switch (e.keyCode) {
        case keyCodes.tab:
          if (e.shiftKey && thisMenu.inMenuMode) {
            e.preventDefault();
            thisMenu.$targetsLastTabbable.focus();
          }
          break;
        case keyCodes.escape:
          e.preventDefault();
          thisMenu.$target.hide().attr("aria-hidden", "true");
          thisMenu.$el.removeClass("is-open");
          break;
        case keyCodes.enter:
        case keyCodes.space:
          e.preventDefault();
          thisMenu.$thingClickedOn = $(this);
          thisMenu.OpenSesame();
          // thisMenu.$target
          //   .toggle()
          //   .attr("aria-hidden", thisMenu.getHiddenState());
          // thisMenu.$el.toggleClass("is-open");
          // thisMenu.inMenuMode = !thisMenu.inMenuMode;
          // if (thisMenu.preventBodyScroll) {
          //   $("body").toggleClass("is-scroll-frozen");
          // }
          // if (thisMenu.inMenuMode) {
          //   if (thisMenu.$focus) {
          //     thisMenu.$focus.focus();
          //   } else {
          //     thisMenu.$targetsFirstTabbable.focus();
          //   }
          // }
          break;
        default:
      }
    });

    /* Click controls for trigger open */
    this.$el.on("click", function () {
      thisMenu.$thingClickedOn = $(this);
      thisMenu.OpenSesame();
    });

    $(window).on("resize", (event) => {
      var mobileMenuOpen = $(thisMenu.$el).hasClass("is-open");

      // console.log("has is-open class: " + mobileMenuOpen);
      // console.log("wider than tab: " + thisMenu.widerThanTablet);

      if (thisMenu.$el.attr("data-target") === "headernavigation") {
        if (throttler) {
          // console.log("clearing timeout");
          window.clearTimeout(throttler);
        }
        throttler = setTimeout(() => {
          thisMenu.manageBreakpointBehaviors(mobileMenuOpen);
        }, 200);
      }
    });
  }

  OpenSesame() {
    let thisMenu = this;
    
      console.log(thisMenu.$thingClickedOn);

      $(thisMenu.$el).toggleClass("is-open");
      thisMenu.showHidePrimaryNav(thisMenu.$el.hasClass("is-open"));
      // console.log(thisMenu.$el.hasClass("is-open"));

      if (thisMenu.$primaryNavMenu.hasClass("animate__animated")) {
        thisMenu.$primaryNavMenu.toggleClass("animate__fadeInDown");
        thisMenu.$primaryNavMenu.toggleClass("animate__fadeOutUp");
        thisMenu.$mobileMenuExpand.attr("disabled", "true");
        thisMenu.preventBodyScroll = false;
      }

      if (thisMenu.inMenuMode) {
        if (thisMenu.$focus) {
          thisMenu.$focus.focus();
        } else {
          thisMenu.$targetsFirstTabbable.focus();
        }
      }
    }

    CloseSesame() {
      let thisMenu = this;
      //thisMenu.$el.focus();
      if (
        thisMenu.$primaryNavMenu.hasClass("animate__animated") &&
        $(window).width() > 860
      ) {
        thisMenu.$primaryNavMenu.removeClass("animate__fadeInDown");
        thisMenu.$primaryNavMenu.addClass("animate__fadeOutUp");
        throttler = setTimeout(() => {
          thisMenu.showHidePrimaryNavDesktopAllSizes(false);
        }, 350);
      } else {
        thisMenu.showHidePrimaryNav(false);
      }
      thisMenu.inMenuMode = false;
      $("body").removeClass("is-scroll-frozen");
      $(thisMenu.$thingClickedOn).focus();
    }

  findAndChangeOtherHamburger() {
    let thisMenu = this;
    let isOpenNow = thisMenu.$el.hasClass("is-open");
    // console.log(isOpenNow + " isOpenNow||| " + thisMenu.hasMatchingTarget);
    // console.log(thisMenu.$mobileMenuExpand);

    if (thisMenu.hasMatchingTarget && isOpenNow) {
      let allJSHamburger = $(thisMenu.$mobileMenuExpand).find(
        ".js-primary-hamburger"
      );
      allJSHamburger.each(function () {
        $(this).addClass("is-open");
      });
    } else if (thisMenu.hasMatchingTarget && !isOpenNow) {
      let allJSHamburger = $(thisMenu.$mobileMenuExpand).find(
        ".js-primary-hamburger"
      );
      allJSHamburger.each(function () {
        $(this).removeClass("is-open");
      });
    }
  }
  /* Helper function to grab current open state */
  getHiddenState() {
    return this.$target.attr("aria-hidden") === "true" ? "false" : "true";
  }

  /*
    Handle changes on breakpoint.
    In general, we want to close/hide the menu as appropriate when switching between
      major breakpoints, as well as set or unset the appropriate aria attributes
  */
  manageBreakpointBehaviors(mobileMenuOpen) {
    let thisMenu = this;

    // console.log(thisMenu.$el);
    // console.log(mobileMenuOpen);
    // console.log(breakpoint());
    if (
      (breakpoint() === "xsmall" || breakpoint() === "xxsmall" || breakpoint() === "small") && mobileMenuOpen) {
      // console.log(thisMenu.$el.attr("data-target") + " data-target OPEN WAH");
      // Show mobile menu
      thisMenu.$primaryNavMenu.removeClass("animate__animated");
      thisMenu.widerThanTablet = false;

    } else if ((breakpoint() === "xsmall" || breakpoint() === "xxsmall" || breakpoint() === "small") && !mobileMenuOpen) {
      // console.log(thisMenu.$el.attr("data-target") + " data-target CLOSED dd");
      // Show mobile menu
      thisMenu.showHidePrimaryNav(false);
      thisMenu.widerThanTablet = false;
      thisMenu.$primaryNavMenu.removeClass("animate__animated");
      if (
        $(thisMenu.$target).hasClass("hamburger_active_all_breakpoints")
      ) {
        thisMenu.$primaryNavMenu.removeClass("animate__fadeInDown");
        thisMenu.$primaryNavMenu.addClass("animate__fadeOutUp");
      }
    } else {
      // On desktop view, force menu to appear after visiting mobile view
      // console.log("else");
      // if menu is always openable
      if ($(thisMenu.$target).hasClass("hamburger_active_all_breakpoints")) {
        let isOpenNow = false;
        // console.log(isOpenNow + " isOpenNow||| " + thisMenu.hasMatchingTarget);

        let allJSHamburger = $(thisMenu.$mobileMenuExpand).find(
          ".js-primary-hamburger"
        );
        allJSHamburger.each(function () {
          // console.log($(this));
          $(this).removeClass("is-open");
        });

        thisMenu.$target
          .hide()
          .attr("aria-hidden", "true")
          .css("display", "none");
        thisMenu.inMenuMode = false;
        thisMenu.$el.removeClass("is-open");
        // console.log(thisMenu.$el);
        // console.log(thisMenu.$el.hasClass("is-open"));
        thisMenu.$primaryNavMenu.addClass("animate__animated");
      } else if (!this.widerThanTablet) {
        // console.log("else if");
        thisMenu.showHidePrimaryNav(false);
      } else {
        thisMenu.showHidePrimaryNav(false);
      }
      if (
        $(thisMenu.$target).hasClass("hamburger_active_all_breakpoints")
      ) {
        thisMenu.$primaryNavMenu.removeClass("animate__fadeInDown");
        thisMenu.$primaryNavMenu.addClass("animate__fadeOutUp");
      }

      $("body").removeClass("is-scroll-frozen");
      thisMenu.widerThanTablet = true;
    }
  }

  showHidePrimaryNav(trueFalse) {
    let thisMenu = this;
    // console.log("showHidePrimaryNav BeforeFork " + trueFalse);
    // console.log(typeof trueFalse);
    if (trueFalse === true) {
      // console.log("showHidePrimaryNav true");

      thisMenu.$primaryNavMenu.show().attr("aria-hidden", "false").css("display", "block");
      thisMenu.$target.show().attr("aria-hidden", "false").css("display", "block");
      thisMenu.inMenuMode = true;

      thisMenu.$el.addClass("is-open");
      $("body").addClass("is-scroll-frozen");
      thisMenu.findAndChangeOtherHamburger();

    } else {
      // console.log("showHidePrimaryNav false");

      thisMenu.$primaryNavMenu.hide().attr("aria-hidden", "true").css("display", "");
      thisMenu.$target.hide().attr("aria-hidden", "true").css("display", "");
      thisMenu.inMenuMode = false;

      thisMenu.$el.removeClass("is-open");
      //thisMenu.$primaryNavMenu.removeClass("animate__animated");
      thisMenu.findAndChangeOtherHamburger();

      $("body").removeClass("is-scroll-frozen");
    }
  }
  showHidePrimaryNavDesktopAllSizes(trueFalse) {
    let thisMenu = this;
    // console.log("showHidePrimaryNav BeforeFork " + trueFalse);
    // console.log(typeof trueFalse);
    if (trueFalse === true) {
      // console.log("showHidePrimaryNav true");

      thisMenu.$primaryNavMenu.show().attr("aria-hidden", "false");
      thisMenu.$target.show().attr("aria-hidden", "false");
      thisMenu.inMenuMode = true;

      thisMenu.$el.addClass("is-open");
      $("body").addClass("is-scroll-frozen");
      thisMenu.findAndChangeOtherHamburger();

    } else {
      // console.log("showHidePrimaryNav false");

      thisMenu.$primaryNavMenu.hide().attr("aria-hidden", "true");
      thisMenu.$target.hide().attr("aria-hidden", "true");
      thisMenu.inMenuMode = false;

      thisMenu.$el.removeClass("is-open");
      //thisMenu.$primaryNavMenu.removeClass("animate__animated");
      thisMenu.findAndChangeOtherHamburger();

      $("body").removeClass("is-scroll-frozen");
    }
  }
}
